export const constants = {
  MFE_NAME: 'frInvestment',
  MFE_EXPOSED_PATH: './FrInvestmentApp',
};
